<!-- Forgot password form -->
<form *ngIf="!forgotIDSent" (ngSubmit)="sendMail()" [formGroup]="mailForm"
      class="login-form login-view-2">
  <h3 class="login-form-header">{{ 'login.forgot_password' | translate }}</h3>
  <span class="advice" [innerHTML]="('login.forgot_advice' | translate) | safeHtml"></span>

  <div class="inputs">
    <div class="form-group is-invalid">
      <app-input-regular
        [autocomplete]="'username'"
        [controlForm]="mailForm.controls[MailForm.FIELDS.MAIL]"
        [displayErrorDynamic]="displayErrorDynamic"
        [typeInput]="'text'"
        [placeHolder]="'login.email'"
        [typeLabel]="'basic'">
      </app-input-regular>
    </div>
    <div *ngIf="getError(); let error" class="login-errors">
      <div>{{ error }}</div>
    </div>
  </div>

  <div class="login-button-container">
    <div class="grey-button" (click)="cancel.emit()">
      <i class="pi pi-arrow-left"></i> {{ 'login.cancel' | translate }}
    </div>
    <app-button [label]="'login.send'" [disabled]="loading"></app-button>
  </div>
</form>

<!-- Email sent confirmation -->
<div *ngIf="forgotIDSent" class="login-form login-view-3">
  <h3 class="login-form-header">{{ 'login.emailSent' | translate }}</h3>
  <div class="login-form-bodySend">
    <span>{{ 'login.emailSentBody1' | translate }}</span><br>
    <span>{{ 'login.emailSentBody2' | translate }}</span>
  </div>
  <div class="login-button-container">
    <app-button type="button" [label]="'login.connect'" (click)="backToLogin()"></app-button>
  </div>
</div>
